import React, { useEffect, useState } from 'react';
import { getUserRole } from '../../lib/helpers';
import { useMigrationData } from './hooks/useMigrationData';
import { isDiscoveryEnabled, isMigrationEnabled } from '../../layout/sidebar/hooks/useNavigation';
import { DiscoveryDashboard } from '../Discovery/Dashboard';
import { NotificationsPanel } from '../../components/NotificationsPanel';
import { useNotificationsPanel } from '../../providers/NotificationsPanelProvider';
import { MigrationDashboard } from './MigrationDashboard';

import './HomePageWrapper.scss';

export const HomePageWrapper = () => {
    const [userOrg, setUserOrg] = useState(() => sessionStorage.getItem('userOrg'));

    // Fetch data for the home page dashboard cards
    const { migrationData } = useMigrationData({
        userOrg,
    });

    // Get the user org from session storage when the page initially loads
    useEffect(() => {
        let storedUserOrg = sessionStorage.getItem('userOrg');
        setUserOrg(storedUserOrg);
    }, []);

    const { notifications, isLoading: isNotificationsLoading } = useNotificationsPanel();

    // Render DiscoveryDashboard if discovery is enabled
    const showDiscovery = isDiscoveryEnabled();
    // Render MigrationDashboard if migration is enabled
    const showMigration = isMigrationEnabled();

    return (
        <div className="home-page-wrapper">
            <NotificationsPanel notifications={notifications} isLoading={isNotificationsLoading} />
            {showDiscovery && <DiscoveryDashboard />}
            {showMigration && <MigrationDashboard migrationData={migrationData} getUserRole={getUserRole} />}
        </div>
    );
};
